import { render, staticRenderFns } from "./AppPreviewFooter.vue?vue&type=template&id=a0b7d53c&scoped=true&"
import script from "./AppPreviewFooter.vue?vue&type=script&lang=js&"
export * from "./AppPreviewFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppPreviewFooter.vue?vue&type=style&index=0&id=a0b7d53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b7d53c",
  null
  
)

export default component.exports